import Svg from '@doordash/component-svg'
import * as React from 'react'

export const Gift: React.FC<{
  width?: number
  height?: number
  color?: string
}> = ({ width = 72, height = 72, color = 'none' }) => (
  <Svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={color}
  >
    <path
      d="M18.5391 43.5823C18.5385 45.1466 19.06 68.2229 19.06 68.2229C19.06 68.2229 53.7375 69.0043 54.5205 67.4388C55.3038 65.8751 54.5198 40.8446 54.5198 40.8446L18.5391 43.5823Z"
      fill="#528C8F"
    />
    <path
      d="M15.0209 36.9336C14.6296 37.4554 15.4115 46.3199 15.4115 46.3199L56.8691 45.9294C56.8691 45.9294 57.2598 36.9341 56.348 36.4127C55.4348 35.891 15.4119 36.4131 15.0209 36.9336Z"
      fill="#74A3A5"
    />
    <path
      d="M31.9507 36.2816V46.4513L40.1031 46.1907L40.206 36.0183L31.9507 36.2816Z"
      fill="#FF3008"
    />
    <path
      d="M31.7468 68.4829C32.9708 68.4828 40.7155 68.2215 40.7155 68.2215L40.0021 46.1906L31.8487 46.3196L31.7468 68.4829Z"
      fill="#DA260D"
    />
    <path
      d="M17.2365 32.568C18.2965 33.3112 28.0218 30.3163 34.0378 36.3802C35.3625 33.7171 37.0807 32.8258 37.0807 32.8258C37.0807 32.8258 34.6741 29.861 30.2667 26.8139C28.148 25.348 24.5442 24.3854 24.2466 24.6349C23.4842 25.2753 22.287 25.902 21.0323 27.383C18.8052 30.016 16.1764 31.8247 17.2365 32.568Z"
      fill="#FF3008"
    />
    <path
      d="M54.8417 34.4571C54.4726 35.0982 44.7109 31.0778 38.2152 36.5337C35.488 32.4359 35.382 32.4207 35.382 32.4207C35.382 32.4207 47.7753 25.0491 50.2155 26.3565C52.3346 29.6516 55.2121 33.8161 54.8417 34.4571Z"
      fill="#FF3008"
    />
    <path
      d="M31.1724 37.2367C31.1724 37.2367 31.9266 35.38 33.3432 33.2544C34.0288 32.2287 37.4489 32.3425 37.4489 32.3425C37.4489 32.3425 39.366 33.5643 39.9213 35.1674C40.3725 36.4688 40.4932 37.7153 40.5343 37.9155C40.6221 38.3612 35.1547 39.4212 31.1724 37.2367Z"
      fill="#DA260D"
    />
    <path
      d="M53.6136 14.5432C53.5478 14.6735 53.5615 14.8312 53.7713 14.8861C53.9811 14.9409 55.4553 15.2495 55.9119 16.0805C56.252 16.6989 56.5921 17.9167 56.7429 17.9715C56.8924 18.0277 57.0309 17.9839 57.0282 17.8947C57.0254 17.8056 57.3079 15.9886 57.8811 15.5745C58.5915 15.0616 60.0848 14.9437 60.0958 14.6077C60.1013 14.4582 59.4362 14.3855 58.8383 14.2237C58.239 14.0592 57.3902 13.427 57.2256 12.777C57.0611 12.127 56.7992 11.1821 56.6785 11.1561C56.5592 11.13 56.5386 12.6782 56.0175 13.1939C55.5238 13.682 55.1166 13.9755 54.6448 14.1606C54.1841 14.3403 53.6616 14.4472 53.6136 14.5432Z"
      fill="#FF3008"
    />
    <path
      d="M48.0728 2.70001C47.7697 3.39156 47.9886 3.87019 48.5841 3.92479C49.1791 3.97754 49.4096 3.98225 49.6075 3.51742C49.7701 3.13328 49.8745 2.79734 49.3012 2.45313C48.4675 1.95008 48.0728 2.70001 48.0728 2.70001Z"
      fill="#74A3A5"
    />
    <path
      d="M16.025 4.91916C15.7217 5.61214 15.941 6.09061 16.5372 6.14359C17.1315 6.19713 17.3621 6.20168 17.5603 5.73551C17.7232 5.35311 17.8292 5.01652 17.2544 4.67207C16.4198 4.17082 16.025 4.91916 16.025 4.91916Z"
      fill="#74A3A5"
    />
    <path
      d="M66.085 24.5025C65.7818 25.1955 66.0017 25.6728 66.5973 25.727C67.1916 25.7805 67.4221 25.7851 67.6203 25.3189C67.7833 24.9365 67.8892 24.5999 67.3133 24.2548C66.4798 23.7542 66.085 24.5025 66.085 24.5025Z"
      fill="#74A3A5"
    />
    <path
      d="M44.5836 15.7496C44.3258 16.7287 44.7015 17.2567 44.9634 17.6256C45.2267 17.9958 46.033 18.4182 46.6049 18.3674C47.4441 18.292 48.1572 17.4212 48.1572 17.4212C48.1572 17.4212 48.4466 16.2625 48.101 15.5521C47.7554 14.8445 47.3509 14.4976 46.6803 14.3371C46.0097 14.1781 45.8781 14.3371 45.4489 14.5908C44.7042 15.031 44.5836 15.7496 44.5836 15.7496Z"
      fill="#74A3A5"
    />
    <path
      d="M17.7419 10.9061C17.4841 11.8852 17.8585 12.4131 18.1218 12.782C18.3851 13.1523 19.19 13.5746 19.7633 13.5239C20.6025 13.4485 21.3156 12.5777 21.3156 12.5777C21.3156 12.5777 21.6049 11.4189 21.2594 10.71C20.9138 10.001 20.5079 9.65405 19.8387 9.49498C19.1681 9.33454 19.0365 9.49361 18.6059 9.7473C17.8626 10.1889 17.7419 10.9061 17.7419 10.9061Z"
      fill="#74A3A5"
    />
    <path
      d="M27.9369 10.5581C27.786 10.8612 27.8217 11.2274 28.3071 11.3494C28.7926 11.4714 32.2126 12.1626 33.285 14.0783C34.0831 15.5058 34.8922 18.317 35.2405 18.4432C35.5888 18.5694 35.9069 18.4679 35.9001 18.2622C35.8932 18.0551 36.5172 13.8411 37.835 12.8729C39.4723 11.6717 42.9281 11.3755 42.9473 10.5938C42.9569 10.251 41.4169 10.0946 40.0277 9.72713C38.6386 9.35825 36.6625 7.90877 36.2703 6.40719C35.8768 4.90423 35.2542 2.72247 34.9772 2.66213C34.6988 2.60179 34.6782 6.18777 33.4797 7.39316C32.3456 8.53135 31.4049 9.21975 30.3175 9.65445C29.2519 10.0782 28.0479 10.336 27.9369 10.5581Z"
      fill="#E5BBB7"
    />
    <path
      d="M0.937468 32.4352C0.246459 32.5847 0.00297795 33.0122 0.288592 33.4937C0.572663 33.974 0.696213 34.1496 1.15691 34.0467C1.53681 33.9604 1.84953 33.8583 1.79777 33.2342C1.72093 32.3244 0.937468 32.4352 0.937468 32.4352Z"
      fill="#74A3A5"
    />
    <path
      d="M61.968 29.4775C61.0232 29.8395 60.8148 30.4525 60.668 30.8831C60.5213 31.3123 60.6502 32.2133 61.0259 32.648C61.5772 33.2843 62.7017 33.3542 62.7017 33.3542C62.7017 33.3542 63.8111 32.9099 64.1841 32.216C64.5571 31.5221 64.601 30.9901 64.339 30.3524C64.0771 29.7161 63.8714 29.7024 63.4134 29.5022C62.6221 29.1552 61.968 29.4775 61.968 29.4775Z"
      fill="#74A3A5"
    />
    <path
      d="M4.093 31.3594C4.02032 31.5021 4.03541 31.6735 4.26305 31.7338C4.49205 31.7941 6.09786 32.1397 6.59154 33.0489C6.96042 33.7263 7.32519 35.0551 7.48837 35.1168C7.65156 35.1785 7.80241 35.1319 7.79966 35.0346C7.79829 34.9372 8.11644 32.9557 8.74313 32.5072C9.52066 31.9518 11.1498 31.8312 11.1649 31.4637C11.1704 31.3018 10.4463 31.2182 9.79355 31.0372C9.14218 30.8562 8.21928 30.1609 8.04239 29.4519C7.86549 28.7416 7.58574 27.7104 7.45546 27.6802C7.32519 27.65 7.29365 29.3395 6.72181 29.9004C6.18151 30.4297 5.73446 30.7492 5.22022 30.9467C4.71558 31.1414 4.14648 31.2552 4.093 31.3594Z"
      fill="#FF3008"
    />
  </Svg>
)

export default Gift
